  <div class="w-100 d-flex  justify-content-between">
    <div>
      <span>{{headingText}}</span>
    </div>
    <div>
      <span class="fnt-size10px">
        {{selectedList?.length ? selectedList?.length : 0}}/{{maxLength}}
      </span>
    </div>
</div>
<label class="primary-small" *ngIf="err_msg && showUserList">
  <span class="color-error">
    {{err_msg}}
  </span>
</label>
<div class="position-relative custom-dropdown mt-1">
    <span class="icon-left">
      <img src="assets/themes/icons/Search.svg"  alt="search"  />
    </span>
    <input  autocomplete="off"
      id="userSearch"
      class="input-field" (focus)="emitOnFocus()" (keyup)="subject.next($event.target.value)" />
    <span class="icon-right cursor-pointer" *ngIf="searchKeyValue">
      <img src="assets/themes/icons/cancel.svg"
        width="16"
        height="16"
        (click)="clearSearch()"
        alt="clear search" />
    </span>
  </div>

<div class="post-modal-tag-list mb-3 mt-3  scrollbox py-2" id="listElem" *ngIf ="showUserList"
infiniteScroll [infiniteScrollDistance]="0.4" [infiniteScrollThrottle]="50"
              (scrolled)="onScroll()" [scrollWindow]="false" style="max-height:70%">
  <div *ngFor="let user of userList">
    <label class="row post-modal-tag-list-card mx-0 mb-2 p-2">
      <div class="col-2 pr-1 pl-0 pt-1">
        <ng-container>
          <div class="prflclass">
            <img *ngIf="user.fileCode" [src]="user.fileCode" class="box-48 rounded-circle" onError="this.src='assets/themes/icons/user-profile-placeholder.svg';">
            <img *ngIf="!user.fileCode" src="assets/themes/icons/user-profile-placeholder.svg" alt="user profile pic" />
          </div>
        </ng-container>
      </div>
      <div class="col-7 px-lg-0">
        <p  class="paragraph-bold"> {{user.fullName.length > 20 ? user.fullName.slice(0,20) + "..." : user.fullName  }} <span></span><br ><span  class="secondary-paragraph ng-star-inserted"><span  class="color-grey-500 fnt-size12px"> {{user.speciality.length > 20 ? user.speciality.slice(0,20) + "..." : user.speciality}} </span></span>
        </p>
      </div>
      <div class="col-3 text-right">
        <label class="checkbox">
          <input type="checkbox"  [checked]="isSelected(user.uuid)" (click)="addOrRemoveTag($event, user)" value="user.uuid">
          <span></span>
        </label>
      </div>
    </label>
  </div>
  <div *ngIf="userList?.length === 0">
    <div class="d-flex align-items-center">
      <img src="assets/images/no-result-found.png" class="mx-auto" alt="" />
    </div>
    <p class="mt-1 text-center">{{noResultText}}</p>
  </div>
</div>
